import React from 'react';
import { SecureRoute } from '@okta/okta-react';
import Upload from './Upload';

const UploadRoutes = () => [<SecureRoute key="upload" path="/upload" component={Upload} />];

export default UploadRoutes;